import React from "react";
import Button from "../../Button";
import FontAwesomeIcon from "../../Icon";
import Row from "../../Row";
import Col from "../../Col";
import { SortIcon } from "./SortIcon";

export const AddKeyInformation = ({
  keys,
  data,
  onAddKey,
  onSetKey,
  onSetEditKey,
  handlekeyDelete,
  handleKeyPress,
  onSortingKey,
  onClearFormData,
}) => {
  let validation =
    data.name &&
    data.name.trim() //&&
    // data.email &&
    // data.email.trim() &&
    // data.phone &&
    // data.phone.trim();
  let isIdsAvailable =
    keys && keys.length > 0 ? keys.filter((cl) => cl.id) : [];

  return (
    <div class="input_box">
      {keys && keys.length > 0
        ? keys
            .filter((q) => !q.isdeleted)
            .map((key, index) => {
              return (
                <div
                  className="homeOwnercard mt-15 mb-15 addKeyCard"
                  draggable={
                    (isIdsAvailable && isIdsAvailable.length === 0) || key.id
                      ? true
                      : false
                  }
                  onDragStart={() => onSortingKey(key, index, "start")}
                  onDrop={() => onSortingKey(key, index, "drop")}
                  onDragOver={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                >
                  <Row>
                    <Col md={12} xs={6}>
                      {(isIdsAvailable && isIdsAvailable.length === 0) ||
                      key.id ? (
                        <SortIcon />
                      ) : null}
                      <div
                        className="deleteIcon"
                        style={{
                          textAlign: "right",
                          cursor: "pointer",
                          float: "right",
                        }}
                        onClick={() =>
                          window.confirm(
                            `Are you sure you want to delete Contact?`
                          ) && handlekeyDelete(key)
                        }
                      >
                        <FontAwesomeIcon glyph="trash" weight="light" size="small" />
                        Delete Contact
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3} xs={6}>
                      <div class="homeOwnerinput_section homeOwnerinputContainerkey">
                        <div class="mt-10 inputLablekey">
                          Name:
                          <span className="input__required" />{" "}
                        </div>
                        <div class="inputFormkey">
                          <input
                            class="form-control"
                            type="text"
                            placeholder="Name"
                            aria-label="default input example"
                            value={key.name}
                            onChange={(e) =>
                              onSetEditKey(e.target.value, "name", index)
                            }
                            required
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div class="homeOwnerinput_section homeOwnerinputContainerkey">
                        <div class="mt-10 inputLablekey">Department:</div>
                        <div class="inputFormkey">
                          <input
                            class="form-control"
                            type="text"
                            placeholder="Department"
                            aria-label="default input example"
                            value={key.department}
                            onChange={(e) =>
                              onSetEditKey(e.target.value, "department", index)
                            }
                            required
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div class="homeOwnerinput_section homeOwnerinputContainerkey">
                        <div class="mt-10 inputLablekey">
                          Email:
                          {/* <span className="input__required" />{" "} */}
                        </div>
                        <div class="inputFormkey">
                          <input
                            class="form-control"
                            type="text"
                            placeholder="Email"
                            aria-label="default input example"
                            value={key.email}
                            onChange={(e) =>
                              onSetEditKey(e.target.value, "email", index)
                            }
                           // required
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div class="homeOwnerinput_section homeOwnerinputContainerkey">
                        <div class="mt-10 inputLablekey">
                          Phone Number:
                          {/* <span className="input__required" />{" "} */}
                        </div>
                        <div class="inputFormkey">
                          <input
                            class="form-control"
                            type="text"
                            placeholder="Phone Number"
                            aria-label="default input example"
                            value={key.phone}
                            //onKeyPress={handleKeyPress}
                            //maxLength={10}
                            onChange={(e) =>
                              onSetEditKey(e.target.value, "phone", index)
                            }
                           // required
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })
        : null}

      <div className="homeOwnercard mt-15 mb-15 addKeyCard">
        {data.name || data.department || data.email || data.phone ? (
          <a
            onClick={() => onClearFormData("key")}
            className="clearLink deleteIcon"
            style={{ textAlign: "right", cursor: "pointer", float: "right" }}
          >
            {" "}
            Clear{" "}
          </a>
        ) : null}
        <Row>
          <Col md={3} xs={6}>
            <div class="homeOwnerinput_section homeOwnerinputContainerkey">
              <div class="mt-10 inputLablekey">
                Name:
                <span className="input__required" />{" "}
              </div>
              <div class="inputFormkey">
                <input
                  class="form-control"
                  type="text"
                  placeholder="Name"
                  aria-label="default input example"
                  value={data.name}
                  onChange={(e) => onSetKey(e.target.value, "name")}
                  required
                />
              </div>
            </div>
          </Col>
          <Col md={3} xs={6}>
            <div class="homeOwnerinput_section homeOwnerinputContainerkey">
              <div class="mt-10 inputLablekey">Department:</div>
              <div class="inputFormkey">
                <input
                  class="form-control"
                  type="text"
                  placeholder="Department"
                  aria-label="default input example"
                  value={data.department}
                  onChange={(e) => onSetKey(e.target.value, "department")}
                  required
                />
              </div>
            </div>
          </Col>
          <Col md={3} xs={6}>
            <div class="homeOwnerinput_section homeOwnerinputContainerkey">
              <div class="mt-10 inputLablekey">
                Email:
                {/* <span className="input__required" />{" "} */}
              </div>
              <div class="inputFormkey">
                <input
                  class="form-control"
                  type="text"
                  placeholder="Email"
                  aria-label="default input example"
                  value={data.email}
                  onChange={(e) => onSetKey(e.target.value, "email")}
                  //required
                />
              </div>
              <div className="input__errors">
                {
                  data.email===null || data.email ===''?null:(
                    data.emailValidationMessage && (
                      <div className="input__error">
                        {data.emailValidationMessage}
                      </div>
                    )
                  )
                }
              </div>
            </div>
          </Col>
          <Col md={3} xs={6}>
            <div class="homeOwnerinput_section homeOwnerinputContainerkey">
              <div class="mt-10 inputLablekey">
                Phone Number:
                {/* <span className="input__required" /> */}
              </div>
              <div class="inputFormkey">
                <input
                  class="form-control"
                  type="text"
                  placeholder="Phone Number"
                  aria-label="default input example"
                  value={data.phone}
                  onChange={(e) => {
                    onSetKey(e.target.value, "phone");
                  }}
                  // maxLength={11}
                  //onKeyPress={handleKeyPress}
                 // required
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <Button
        color="teal"
        size="small"
        label="+ Add New Key Contact"
        disabled={!validation}
        onClick={onAddKey}
      />
    </div>
  );
};
